import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';

import PartnerWithUsOne from '../PartnerWithUsForm/PartnerWithUsOne';
import PartnerWithUsTwo from '../PartnerWithUsForm/PartnerWithUsTwo';
import PartnerWithUsThree from '../PartnerWithUsForm/PartnerWithUsThree';
import PartnerWithUsFour from '../PartnerWithUsForm/PartnerWithUsFour';
import PartnerWithUsFive from '../PartnerWithUsForm/PartnerWithUsFive';
import { styled } from "@mui/material/styles"
import Check from '@mui/icons-material/Check';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import ThankYouComponent from '../ThankYouComponent/ThankYouComponent';
import { Modal } from '@mui/material';

import ProgressBar from 'Component/ProgressBar/ProgressBar';
import PartnerWithUsSix from 'Component/PartnerWithUsForm/PartnerWithUsSix';
const steps = ['1', '2', '3', "4", "5","6"];

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#021b38',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#021b38',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#97c11e',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));
const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#97c11e',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  ...(ownerState.active && {
    color: '#021b38',
  }),
  '& .QontoStepIcon-completedIcon': {
    color: '#021b38',
    zIndex: 1,
    fontSize: 18,
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
}));



export default function PartnerWithUs({ SetValue }) {
  const [progress, setProgress] = React.useState(0)
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});
  const [partnerWithUsData, setPartnerWithUsData] = React.useState({
    started_from: new Date().toISOString().split('T')[0],
    first_name: "",
    last_name: "",
    company: "",
    institution_name: "",
    email: "",
    password:"",
    phone: "",
    industry: "",
    other_industry: "",
    city: "",
    state: "",
    additional_info: ""
  })
  function QontoStepIcon(props) {
    const { active, completed, className } = props;

    return (
      <QontoStepIconRoot ownerState={{ active }} className={className}>
        {completed ? (
          <Check className="QontoStepIcon-completedIcon" />
        ) : (
          <div className="QontoStepIcon-circle" />
        )}
      </QontoStepIconRoot>
    );
  }
  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
        // find the first step that has been completed
        steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    if (activeStep === 0) {
      SetValue(false)
    } else {


      setActiveStep((prevActiveStep) => prevActiveStep - 1);
      let keys = Object.keys(completed);
      if (keys.length > 0) {
        let lastElement = keys[keys.length - 1]
        delete completed[lastElement]
      }
    }
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };
  React.useEffect(()=>{
    const interval = setInterval(()=>{
      const progress = localStorage.getItem("progress")
      if(progress !==null){
        setProgress(progress)

      }
    },100)
    return ()=>{
      clearInterval(interval)
    }
  },[])
  return (
    <Box sx={{ width: '100%' }}>

      {/* <Stepper nonLinear activeStep={activeStep}>
        {steps.map((label, index) => (
          <Step key={label} completed={completed[index]}>
            <StepButton color="inherit" onClick={handleStep(index)}>
              
            </StepButton>
          </Step>
        ))}
      </Stepper> */}
      <Stepper sx={{ display: allStepsCompleted() ? "none" : "flex" }} alternativeLabel activeStep={activeStep} connector={<QontoConnector />}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={QontoStepIcon}></StepLabel>
          </Step>
        ))}
      </Stepper>
      <div>
        {allStepsCompleted() ? (
          <React.Fragment>
            {progress < 100 ?

              <Box sx={{ display: "flex", justifyContent: "center" }}  >
                <ProgressBar progress={progress} />
              </Box>
              :
              <Modal open={true} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }} >
                <ThankYouComponent />
              </Modal>
            }

            {/* <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <Box sx={{ flex: '1 1 auto' }} />
              <Button onClick={handleReset}>Reset</Button>
            </Box> */}
          </React.Fragment>
        ) : (

          <React.Fragment>
            {activeStep === 0 ? <PartnerWithUsOne handleBack={handleBack} handleComplete={handleComplete} partnerWithUsData={partnerWithUsData} setPartnerWithUsData={setPartnerWithUsData} /> :
              activeStep === 1 ? <PartnerWithUsTwo handleBack={handleBack} handleComplete={handleComplete} partnerWithUsData={partnerWithUsData} setPartnerWithUsData={setPartnerWithUsData} /> :
                activeStep === 2 ? <PartnerWithUsSix handleBack={handleBack} handleComplete={handleComplete} partnerWithUsData={partnerWithUsData} setPartnerWithUsData={setPartnerWithUsData} /> :
                  activeStep === 3 ? <PartnerWithUsThree handleBack={handleBack} handleComplete={handleComplete} partnerWithUsData={partnerWithUsData} setPartnerWithUsData={setPartnerWithUsData} /> :
                    activeStep === 4 ? <PartnerWithUsFour handleBack={handleBack} handleComplete={handleComplete} partnerWithUsData={partnerWithUsData} setPartnerWithUsData={setPartnerWithUsData}  /> :
                    activeStep === 5 ? <PartnerWithUsFive handleBack={handleBack} handleComplete={handleComplete} partnerWithUsData={partnerWithUsData} setPartnerWithUsData={setPartnerWithUsData}  /> :

                      ""}

          </React.Fragment>

        )}
      </div>







    </Box>
  );
}
